import React from 'react';
import SignIn from '@/components/SignIn';

export function meta() {
  return [
    { title: 'Sign In | SimulationsLabs' },
    { name: 'description', content: 'Sign in to your account' },
    { name: 'robots', content: 'noindex, follow' },
  ];
}

export default function Auth() {
  return (
    <div className="bg-lighterGray flex min-h-screen items-center justify-center">
      <SignIn />
    </div>
  );
}
